import React from "react";
import PropTypes from "prop-types";

// SVG Icons for education items
const GraduationCapIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
        <path d="M6 12v5c3 3 9 3 12 0v-5" />
    </svg>
);

const CalendarIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
);

const BuildingIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
        <path d="M9 22v-4h6v4" />
        <path d="M8 6h.01" />
        <path d="M16 6h.01" />
        <path d="M12 6h.01" />
        <path d="M12 10h.01" />
        <path d="M12 14h.01" />
        <path d="M16 10h.01" />
        <path d="M16 14h.01" />
        <path d="M8 10h.01" />
        <path d="M8 14h.01" />
    </svg>
);

const StudyItem = ({ data, index }) => {
    return (
        <div
            className={`education-card ${data.className?.replace(
                "text-",
                "border-"
            )}`}
        >
            <div className="education-card__timeline">
                <div className="education-card__dot" />
                <div className="education-card__line" />
            </div>

            <div className="education-card__content">
                <div className="education-card__icon">
                    <GraduationCapIcon />
                </div>

                <div className="education-card__body">
                    <div className="education-card__header">
                        <span
                            className={`education-card__badge ${data.className}`}
                        >
                            {data.year === "Continue" ? "Ongoing" : data.year}
                        </span>
                    </div>

                    <h4 className="education-card__title">{data.degree}</h4>

                    <div className="education-card__details">
                        <div className="education-card__detail">
                            <BuildingIcon />
                            <span>{data.institution}</span>
                        </div>
                        <div className="education-card__detail">
                            <CalendarIcon />
                            <span>
                                {data.year === "Continue"
                                    ? "Currently Studying"
                                    : `Passed: ${data.year}`}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

StudyItem.propTypes = {
    data: PropTypes.shape({
        className: PropTypes.string,
        degree: PropTypes.string.isRequired,
        institution: PropTypes.string.isRequired,
        year: PropTypes.string.isRequired,
    }).isRequired,
    index: PropTypes.number,
};

export default StudyItem;
